import React from "react";
import { Tooltip } from "@mui/material";
import { capitalizeFullName } from "../utils/nameUtils";
import { commonConstants } from "../utils/constant";

const PodcastCard = ({ 
  podcast, 
  index, 
  onPrimaryAction, 
  onSecondaryAction, 
  primaryButtonText, 
  secondaryButtonText, 
  secondaryButtonIcon,
  showSecondaryButton = true 
}) => {
  return (
    <div key={index} className="card-container">
      <div className="card-body">
        <div className="card-podcast-content">
          <div className="card-podcast-title">
            <div className="card-podcast-titleValue">
              {podcast.Title}
            </div>
            <div className="card-podcast-timeGuest">
              <div className="card-podcast-time">
                Host: {capitalizeFullName(podcast.Host)}
                <br />
                Date/Time:{" "}
                {new Date(podcast.StartDttm).toLocaleString("en-US", {
                  hour12: true,
                  hour: "2-digit",
                  minute: "2-digit",
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                })}
              </div>
              <div className="card-podcast-time">
                Guests:{" "}
                {JSON.parse(podcast?.Guests || "[]")
                  ?.slice(0, 2)
                  .map((guest, idx) => (
                    <span key={idx}>
                      {capitalizeFullName(guest)}
                      {idx < 1 && ", "}
                    </span>
                  ))}
                {JSON.parse(podcast?.Guests || "[]")?.length > 2 && (
                  <Tooltip
                    title={JSON.parse(podcast?.Guests || "[]")
                      ?.slice(2)
                      .map(guest => capitalizeFullName(guest))
                      .join(", ")}
                    arrowplacement="top"
                  >
                    <span className="more-guests">
                      {` +${JSON.parse(podcast?.Guests || "[]")?.length - 2}`}
                    </span>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="card-podcast-agenda">
          <div className="card-podcast-agenda-container">
            <div className="card-podcast-agendaTitle">Agenda</div>
            <div className="card-podcast-agendaContent">
              {podcast?.Agenda ? (
                <Tooltip
                  arrow
                  title={
                    <div
                      className="tooltip-agenda-container"
                      dangerouslySetInnerHTML={{ __html: podcast.Agenda }}
                    />
                  }
                >
                  <div
                    className="agenda-main-container"
                    dangerouslySetInnerHTML={{ __html: podcast.Agenda }}
                  />
                </Tooltip>
              ) : (
                commonConstants.NO_AGENDA
              )}
            </div>
          </div>
        </div>

        <div className="podcast-card-button">
          <button className="reschedule-button" onClick={() => onPrimaryAction(podcast)}>
            {primaryButtonText}
          </button>
          {showSecondaryButton && !podcast.guest && (
            <button className="remove-button" onClick={(event) => onSecondaryAction(podcast, event)}>
              {secondaryButtonText}
              {secondaryButtonIcon && (
                typeof secondaryButtonIcon === 'string' ? (
                  <img
                    src={secondaryButtonIcon}
                    alt={secondaryButtonText}
                    style={{ width: "1.8vw", height: "1.8vh" }}
                  />
                ) : (
                  secondaryButtonIcon
                )
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PodcastCard;